import { QuoteCard as HygraphQuoteCardProps } from '@/lib/types';

import QuoteCard from '@/components/quote-card';

import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';
import richTextTransformer from '@/hygraph/transformers/rich-text.transformer';

export default function QuoteCardRenderer(props: HygraphQuoteCardProps) {
  return (
    <QuoteCard
      authorName={props.authorName}
      quote={richTextTransformer({ content: props.quote.raw })}
      authorImage={hygraphImageTransformer(props.authorImage)}
      jobTitle={props.jobTitle || undefined}
    />
  );
}
